<app-header title="Manage Campaigns"></app-header>
<ng-container [formGroup]="option">
    <div>
        <div class="card__title mb-4">Option image</div>
        <div class="row mb-3">
            <div class="col-8">
                <div class="body-1 mb-1">Option Image(s)</div>
                <div mdbSortableContainer class="image-sortable-list d-flex flex-wrap" (itemDrop)="onDrop($event)">
                    @for (image of optionImages; track image; let i = $index) {
                        <div mdbDraggable class="image-sortable-item">
                            <div
                                style="border: 1px solid rgba(0, 0, 0, 0.07); border-radius: 5px;"
                                class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                            >
                                <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="onRemoveImage(i)"></app-icon-delete>
                            </div>
                            <img [src]="image" alt="" style="border-radius: 5px">
                        </div>
                    }
                    <div class="d-flex flex-column align-items-center">
                        <div style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;" class="image-sortable-item">
                            <app-input-file multiple="true" class="position-absolute" [classes]="['btn--paybee-custom']" label="Upload" accept="image/png,image/jpeg" formControlName="imageUrlsFile"></app-input-file>
                        </div>
                        <span  class="d-block blue-text body-2 text-center">OR</span>
                        <a (click)="openChooseImageModal(0)" class="blue-text body-2 mb-2">Choose from previously used images</a>
                    </div>
                </div>
            </div>

            <div class="col-4 d-flex align-items-center flex-column" style="border-left: 1px solid rgba(0,0,0,.07);">
                <div class="d-flex flex-row align-items-center">
                    <div class="body-1 mr-1">Thumbnail</div>
                    <i data-toggle="tooltip" data-placement="left" title="This will be seen by donors viewing this campaign on mobile phones" class="blue-text far fa-question-circle"></i>
                </div>
                
                <div class="image-block mb-1 mt-3 w-50 d-flex justify-content-center">
                    @if(option.controls.thumbnailDataUrl.value === '/images/blank_1x1.png'){
                        <div class="image-block__file-container d-flex align-items-center justify-content-center" style="width: 80%;height:80%">
                            <app-input-file formControlName="thumbnailFile" [classes]="['btn--paybee-custom']" [minSize] ='200' class="position-absolute" label="Upload" accept="image/png,image/jpeg"></app-input-file>
                        </div>
                    }
                    @if(option.controls.thumbnailDataUrl.value !== '/images/blank_1x1.png'){
                        <div class="image-block__file-container d-flex align-items-start justify-content-end">
                            <app-icon-delete (click)="resetImageByType('thumbnail')" class="position-absolute cursor--pointer m-2"></app-icon-delete>
                        </div>
                    }
                    <img class="image-block__image" [src]="option.controls.thumbnailDataUrl.value">
                </div>

                @if(option.controls.thumbnailDataUrl.value === '/images/blank_1x1.png'){
                    <span class="d-block blue-text body-2 text-center">OR</span>
                    <a (click)="openChooseImageModal(1)" class="d-block blue-text body-2 text-center">Choose from previously used images</a>
                    <div [ngStyle]="{'display': chooseImageModalShow ? 'none' : 'flex'}" class=" flex-row align-items-center">
                        <a (click)="generateThumbnail()" class="blue-text body-2 mr-1 text-center">Generate Thumbnail from main image</a>
                    </div>
                }
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <mdb-form-control class="form-fill" >
                    <app-mdbp-input mdbInput formControlName="name" maxLength="128" label='Option Name'></app-mdbp-input>
                    <mdb-error class="form-fill-error"  *ngIf="option.controls.name.hasError('required') && option.controls.name.touched">Please provide Option Name</mdb-error>
                </mdb-form-control>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <mdb-form-control class="form-fill" >
                    <app-mdbp-input mdbInput formControlName="minQuantity" maxLength="4" [isCurrencyMask]="true"  label='Set Min Qty'>
                        <input autocomplete="chrome-off" #inputNameC currencyMask formControlName="minQuantity" maxLength="4" [options]="{ allowNegative: false, prefix: '', inputMode: 1 }"   class="form-control form-control--paybee"/>
                        <mdb-error class="form-fill-error"  *ngIf="option.controls.minQuantity.hasError('required') && option.controls.minQuantity.touched">Please provide Min Qty</mdb-error>
                        <mdb-error class="form-fill-error"  *ngIf="option.controls.minQuantity.value > option.controls.allowedQuantity.value  && option.controls.minQuantity.touched">Min Qty can't be bigger then Max Qty </mdb-error>

                    </app-mdbp-input>
                </mdb-form-control>
            </div>
            <div class="col-4">
                <mdb-form-control class="form-fill" >
                    <app-mdbp-input mdbInput formControlName="allowedQuantity" maxLength="4" [isCurrencyMask]="true"  label='Set Max Qty'>
                        <input autocomplete="chrome-off" #inputNameC currencyMask formControlName="allowedQuantity" maxLength="4" [options]="{ allowNegative: false, prefix: '', inputMode: 1 }"   class="form-control form-control--paybee"/>
                        <mdb-error class="form-fill-error"  *ngIf="option.controls.allowedQuantity.hasError('required') && option.controls.allowedQuantity.touched">Please provide Max Qty</mdb-error>
                    </app-mdbp-input>
                </mdb-form-control>
            </div>
            <div class="col-4">
                <mdb-form-control class="form-fill" >
                    <app-mdbp-input mdbInput formControlName="amount" [isCurrencyMask]="true"  label='Amount'>
                        <input  #inputNameC currencyMask formControlName="amount" [options]="{'precision': 2}"   class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                    <mdb-error class="form-fill-error"  *ngIf="option.controls.amount.hasError('min') && option.controls.amount.touched">Allowed amount $0 or from $1 to $400,000</mdb-error>
                    <mdb-error class="form-fill-error"  *ngIf="option.controls.amount.hasError('required') && option.controls.amount.touched">Allowed amount $0 or from $1 to $400,000</mdb-error>
                    <mdb-error class="form-fill-error"  *ngIf="option.controls.amount.hasError('max') && option.controls.amount.touched">Allowed amount $0 or from $1 to $400,000</mdb-error>
                </mdb-form-control>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <mdb-form-control class="form-fill">
                    <app-mdbp-input mdbInput formControlName="valueProvided" [isCurrencyMask]="true" label='Value of goods or services provided, If any!'>
                        <input  #inputNameC currencyMask formControlName="valueProvided" [options]="{'precision': 2}" class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                    @if(option.controls.valueProvided.hasError('max') && option.controls.valueProvided.touched){<mdb-error class="form-fill-error">Allowed value to {{ AMOUNT_LIMIT.GLOBAL_MAX_STR }}</mdb-error>}
                </mdb-form-control>
            </div>
            <div class="col-4">
              <div class="d-flex align-items-center ml-2 h-100">
                <app-text-popover
                  placement="bottom"
                  type="learn-more"
                  title="Learn more"
                >
                </app-text-popover>
              </div>
            </div>
        </div>

        <div class="row">
            <div class="d-flex align-items-center mat-slide-toggle__wrapper col-12">
                <app-mdb-switch label="Enforce item inventory for this option" formControlName="enforceInventory"></app-mdb-switch>
                <div class="d-flex align-items-center ml-2 h-100">
                    <app-text-popover
                        placement="right"
                        type="content"
                        text="To control the number of items sold in this option, switch this ON. For eg., if you are selling red t-shirts but can only sell 50, you would switch this ON and enter 50 as the inventory count."
                        title=""
                    >
                    </app-text-popover>
                </div>
            </div>

            <div style="padding-left: 44px;" *ngIf="option.value.enforceInventory">
                <div class="position-relative">
                    <mdb-form-control class="form-fill mb-0" >
                        <app-mdbp-input mdbInput formControlName="inventory" [isCurrencyMask]="true"  label='Item inventory count'>
                            <input  #inputNameC currencyMask formControlName="inventory" [options]="{ allowNegative: false, prefix: '', inputMode: 1 }"   class="form-control form-control--paybee"/>
                            <mdb-error class="form-fill-error ml-0"   *ngIf="!isTolalInventoryValid" style="margin-top: 2px;">Please provide Total Inventory bigger then Sold</mdb-error>
                        </app-mdbp-input>
                    </mdb-form-control>
                    <app-text-popover
                        *ngIf="getInventoryErrorState()"
                        type="error"
                        size="sm"
                        placement="bottom"
                        text="Total Inventory should be more then 0"
                        class="form-error--paybee"
                    ></app-text-popover>
                    <div class="d-flex group-ticket-info__container px-2 py-1" style="width: fit-content;font-size: 12px; padding-left: 14px!important;"[ngStyle]="{'margin-top': isTolalInventoryValid?'10px':'20px'}">
                        <div class="group-ticket-info__icon mr-2 d-flex align-items-center">
                            <img src="img/svg/quickpay/group-ticket.svg" height="15" width="15">
                        </div>
                        <div class="group-ticket-info__content" style="font-weight: 400;">
                            {{getSold()}}
                        </div>
                   </div>
                </div>

                <div class="d-flex align-items-center">
                    <app-mdb-switch label="Hide item inventory for this option" formControlName="hideInventory"></app-mdb-switch>
                    <div class="ml-2 h-100">
                        <app-text-popover
                            placement="right"
                            type="content"
                            text="Switch ON to hide the remaining number of items left in this option from donors. If this option is sold out, this is always displayed irrespective of the flag."
                            title=""
                        >
                        </app-text-popover>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="d-flex align-items-center mat-slide-toggle__wrapper col-12">
                <app-mdb-switch label="Send electronic tickets" formControlName="sendTicket" id="sendTicket"></app-mdb-switch>
                <div class="d-flex align-items-center ml-2 h-100">
                    <app-text-popover
                        placement="right"
                        type="content"
                        text="Leave it ON if you want to send a ticket along with the payment confirmation. This is useful if attendees need to be checked in at the party or expect to receive a ticket along with the payment confirmation."
                        title=""
                    ></app-text-popover>
                </div>
            </div>
        </div>

        <div class="row">
            <div style="padding-left: 44px;" *ngIf="option.value.sendTicket">
                <div class="d-flex align-items-center">
                    <app-mdb-switch label="Don't include QR codes in electronic ticket" formControlName="noQrCodeInEmail"></app-mdb-switch>
                    <div class="ml-2 h-100">
                        <app-text-popover
                            placement="right"
                            type="content"
                            text="Turn it ON if you want to send a ticket along with the payment confirmation but do not want to include a QR code for checking attendees in at the party."
                            title=""
                        >
                        </app-text-popover>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="d-flex align-items-center mat-slide-toggle__wrapper col-12">
                <app-mdb-switch label="Display current ticket holders to buyers" formControlName="showTicketHolders" id="showTicketHolders"></app-mdb-switch>
                <div class="d-flex align-items-center ml-2 h-100">
                    <app-text-popover
                        placement="right"
                        type="content"
                        text="If switched ON, the list of ticket holders will be displayed to all buyers."
                        title=""
                    ></app-text-popover>
                </div>
            </div>
        </div>

        <mdb-accordion>
            <mdb-accordion-item [collapsed]="true">
                <ng-template mdbAccordionItemHeader>Collect Additional Information</ng-template>
                <ng-template mdbAccordionItemBody>
                    <app-campaign-form-field-list [presetOption]="option"></app-campaign-form-field-list>
                </ng-template>
            </mdb-accordion-item>
            <mdb-accordion-item [collapsed]="!accordionService.map.host.expanded" (itemShown)="accordionService.onAfterExpand('host')" (itemHidden)="accordionService.onAfterCollapse('host')">
                <ng-template mdbAccordionItemHeader>Host</ng-template>
                <ng-template mdbAccordionItemBody>
                    <div class="row">
                        <div class="col-6">
                            <mdb-form-control class="form-fill">
                                <app-mdbp-input mdbInput formControlName="hostName" maxLength="128" label='Host Name' data-panel="host"></app-mdbp-input>
                                <mdb-error class="form-fill-error"  *ngIf="option.controls.hostName.hasError('required') && option.controls.hostName.touched">Please provide Host Name</mdb-error>
                            </mdb-form-control>
                        </div>
                        <div class="col-6">
                            <mdb-form-control class="form-fill">
                                <app-mdbp-input mdbInput formControlName="hostEmail" maxLength="128" label='Host Email' data-panel="host"></app-mdbp-input>
                                <mdb-error class="form-fill-error" *ngIf="option.controls.hostEmail.hasError('required') && option.controls.hostEmail.touched">Please provide Host Email</mdb-error>
                                <mdb-error class="form-fill-error" *ngIf="option.controls.hostEmail.hasError('pattern') && option.controls.hostEmail.touched">Invalid Host Email</mdb-error>
                            </mdb-form-control>
                        </div>
                    </div>
                    <div class="row">
                        <div class="d-flex align-items-center mat-slide-toggle__wrapper col-12">
                            <app-mdb-switch label="Notify Signups to Host" formControlName="notifyHost"></app-mdb-switch>
                            <div class="d-flex align-items-center ml-2 h-100">
                                <app-text-popover
                                    placement="right"
                                    type="content"
                                    text="If set, the host will get an email notification for each signup."
                                    title=""
                                >
                                </app-text-popover>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="d-flex align-items-center mat-slide-toggle__wrapper col-12">
                            <app-mdb-switch label="Display host information to buyers" formControlName="displayHostInfo"></app-mdb-switch>
                            <div class="d-flex align-items-center ml-2 h-100">
                                <app-text-popover
                                    placement="right"
                                    type="content"
                                    text="Turn it ON if you want to display the host's name to the buyers."
                                    title=""
                                >
                                </app-text-popover>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </mdb-accordion-item>
            <mdb-accordion-item [collapsed]="!accordionService.map.eventSettings.expanded" (itemShown)="accordionService.onAfterExpand('eventSettings')" (itemHidden)="accordionService.onAfterCollapse('eventSettings')">
              <ng-template mdbAccordionItemHeader>Event Date</ng-template>
              <ng-template mdbAccordionItemBody>
                <app-campaign-event-settings
                    [formGroupCampaignTypeData]="option"
                    [submitted]="campaignOptionFormService.submitted"
                 ></app-campaign-event-settings>
              </ng-template>
            </mdb-accordion-item>
            <mdb-accordion-item [collapsed]="true">
                <ng-template mdbAccordionItemHeader>Event Venue</ng-template>
                <ng-template mdbAccordionItemBody>
                    <app-campaign-event-venue
                        [formGroupCampaignTypeData]="option"
                    ></app-campaign-event-venue>
                </ng-template>
              </mdb-accordion-item>
            <mdb-accordion-item [collapsed]="!accordionService.map.optionLiveTime.expanded" (itemShown)="accordionService.onAfterExpand('optionLiveTime')" (itemHidden)="accordionService.onAfterCollapse('optionLiveTime')">
                <ng-template mdbAccordionItemHeader>Option Start/End Date</ng-template>
                <ng-template mdbAccordionItemBody>
                    <div class="body-1 mb-2">Date set here controls if option will be visible to users.</div>
                    <div class="row">
                        <div class="col-12">
                            <app-datetime
                                dateLabel="Start Date"
                                timeLabel="Start Time"
                                formControlName="optionStartDate"
                                [myDatePickerOptions]="partySignupStartTimeOptions"
                                [submitted]="campaignOptionFormService.submitted"
                                data-panel="optionLiveTime"
                            ></app-datetime>
                        </div>
                        <div class="col-12">
                            <app-datetime
                                dateLabel="Stop Date"
                                timeLabel="Stop Time"
                                formControlName="optionEndDate"
                                [myDatePickerOptions]="partySignupEndTimeOptions"
                                [submitted]="campaignOptionFormService.submitted"
                                data-panel="optionLiveTime"
                            ></app-datetime>
                        </div>
                    </div>
                </ng-template>
            </mdb-accordion-item>
        </mdb-accordion>

        <div class="row mt-4 pt-4">
            <div class="col-12">
                <div class="position-relative mb-4">
                    <div class="d-flex flex-row align-items-center mb-1">
                        <label class="form-check-label form-check-label--paybee mr-2">Description</label>
                        <app-text-popover
                            placement="bottom"
                            type="content"
                            text="Add a detailed description to describe this option. This is displayed when donors tap on the Details button when viewing the list of options in this campaign."
                            title=""
                        >
                        </app-text-popover>
                    </div>
                    <mdb-form-control>
                        <app-quill-custom mdbInput formControlName="desc" limit="1024"></app-quill-custom>
                    </mdb-form-control> 
                </div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-12">
                <div class="position-relative mb-4">
                    <div class="d-flex align-items-center mb-2">
                        <div class="d-flex flex-row align-items-center mb-1">
                            <label class="form-check-label form-check-label--paybee mr-2">Summary</label>
                            <app-text-popover
                                placement="bottom"
                                type="content"
                                text="Add a short summary to describe this option. This is displayed when donors are viewing the list of options in this campaign."
                                title=""
                            >
                            </app-text-popover>
                          </div>
                          @if(option.get('desc').value !== ''){
                            <div class="d-flex justify-content-end w-100">
                                <a (click)="generateSummary(0)" class="blue-text body-2">Generate Summary From Description</a>
                            </div>
                          }

                    </div>
                    <mdb-form-control>
                        <app-quill-custom mdbInput formControlName="summary" [options]="quillOptions" limit="256"></app-quill-custom>
                    </mdb-form-control> 
                </div>
            </div>
        </div>
    </div>
</ng-container>
